import type { Metadata } from 'next';
import Link from 'next/link';

import './globals.css';

export const metadata: Metadata = {
  title: 'La Poste WebAR Platform',
  description:
    "Plateforme WebAR mobile-first pour experiences multi-scenes avec image tracking, QR codes et contenus AR simples."
};

export default function RootLayout({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <html lang="fr">
      <body>
        <div className="site-shell">
          <header className="site-header">
            <Link href="/" className="site-header__brand">
              La Poste WebAR Platform
            </Link>
            <p className="site-header__tag">MVP mobile-first image tracking</p>
          </header>
          {children}
        </div>
      </body>
    </html>
  );
}
